// extracted by mini-css-extract-plugin
export default {"link":"CD-z","disabled":"DD-z"};